import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36c50e4b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=36c50e4b&prod&lang=css&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=36c50e4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c50e4b",
  null
  
)

export default component.exports